/**
 * Category glyphs copied from the reference theme-icon set.
 * Live masks: https://img.m167cw.com/mcw/h5/assets/images/icon-set/theme-icon/
 * Color is applied by the nav mask (gold inactive, white active), same as the reference.
 */
import hot from './hot.svg';
import sports from './sports.svg';
import casino from './casino.svg';
import slots from './slots.svg';
import crash from './crash.svg';
import table from './table.svg';
import fishing from './fishing.svg';
import arcade from './arcade.svg';
import lottery from './lottery.svg';

export const CATEGORY_ICON_SRC = {
  hot,
  sports,
  casino,
  slots,
  crash,
  table,
  fishing,
  arcade,
  lottery,
};

export const CATEGORY_ICON_KEYS = Object.keys(CATEGORY_ICON_SRC);
